import { FFmpegLoadTask } from "./task/ffmpeg.ts";
import { computed } from "nanostores";
import { TaskStatus } from "./task/task.ts";

export const loadFFmpegTask = new FFmpegLoadTask();

export const $ffmpegLoaded = computed(loadFFmpegTask.$store, (task) => task.status === TaskStatus.Finished);
